import * as types from './types';

const initialState = {
  users: [],
  next: null,
  usersPending: false,
  usersSuccess: false,
  usersFailure: false,
  selectedUser: null,
};

const usersFetch = state => ({
  ...state,
  next: null,
  usersPending: true,
  usersSuccess: false,
  usersFailure: false,
});

const usersSuccess = (state, payload) => ({
  ...state,
  users: payload.users,
  next: payload.next,
  usersPending: false,
  usersSuccess: true,
  usersFailure: false,
});

const usersFailure = state => ({
  ...state,
  next: null,
  usersPending: false,
  usersSuccess: false,
  usersFailure: true,
});

const selectUser = (state, userId) => ({
  ...state,
  selectedUser: userId,
});

const unselectUser = state => ({
  ...state,
  selectedUser: null,
});

const updateUsersData = (state, payload) => ({
  ...state,
  next: payload.next,
  users: [
    ...state.users,
    ...payload.users,
  ],
});

export default(state = initialState, action) => {
  switch (action.type) {
    case types.USERS_DATA_FETCH:
      return usersFetch(state);
    case types.USERS_DATA_SUCCESS:
      return usersSuccess(state, action.payload);
    case types.USERS_DATA_FAILURE:
      return usersFailure(state);
    case types.SELECT_USER:
      return selectUser(state, action.payload);
    case types.UNSELECT_USER:
      return unselectUser(state);
    case types.UPDATE_USERS_DATA:
      return updateUsersData(state, action.payload);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/users/index.js